import DriverScreen from './index';

const routes = [
  {
    path: '/master/driver',
    component: DriverScreen,
    action: ['manage', 'read_only'],
    service: ['nvo.tms.driver'],
  },
];

export default routes;
